import { render, staticRenderFns } from "./reciteQuestionsMode.vue?vue&type=template&id=d66337d8&scoped=true"
import script from "./reciteQuestionsMode.vue?vue&type=script&lang=js"
export * from "./reciteQuestionsMode.vue?vue&type=script&lang=js"
import style0 from "./reciteQuestionsMode.vue?vue&type=style&index=0&id=d66337d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66337d8",
  null
  
)

export default component.exports